<acf>
  return component('thirds', [
    'sub_fields' => [
      fragment_field(),
      text_field('title'),
      repeater_field('columns', [
        'sub_fields' => [
          text_field('heading'),
          image_field(),
          snippet_field()
        ]
      ])
    ]
  ]);
</acf>

<php>
  return function($content) {
    foreach ($content['field_Thirds_columns'] as $i => $col) {
      $content['field_Thirds_columns'][$i]['field_Thirds_image'] = get_svg_contents($col['field_Thirds_image']);
      $content['field_Thirds_columns'][$i]['field_Thirds_content'] = wpautop($col['field_Thirds_content']);
    }

    return $content;
  };
</php>

<script>
  export default {
    props: ['content']
  }
</script>

<template>
  <section class="section" :id="content.field_Thirds_fragment_id">
    <div class="container">
      <h1 class="title">{{ content.field_Thirds_title }}</h1>
      <div class="columns is-desktop">
        <div class="column" v-for="(col, i) in content.field_Thirds_columns" :key="i">
          <div class="wrap">
            <div class="img" v-html="col.field_Thirds_image"></div>
            <h4 class="subtitle">{{ col.field_Thirds_heading }}</h4>
          </div>
          <div class="content" v-html="col.field_Thirds_content">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
  @import "../sass/variables";

  .section {
    margin-top: 0.75em;
    padding-top: 79px;
    padding-bottom: 79px;
    background: $pippin;
  }

  .title {
    font-size: 3rem;
    color: $pink;
    margin-bottom: 53px;
  }

  .wrap {
    display: flex;
    margin-bottom: 1em;
  }
  .img {
    width: 50%;
    max-width: 200px;
    margin-right: 1em;
  }
  .img /deep/ svg {
    max-width: 100%;
    height: auto;
  }

  .content /deep/ p, .subtitle {
    margin-bottom: 2em;
  }

  .subtitle {
    max-width: 160px;
    font-size: 1.5rem;
  }

  .content /deep/ strong {
    color: $red;
  }

  @include desktop {
    .title {
      text-align: center;
    }

    .subtitle {
      margin-left: auto;
      margin-right: auto;
      position: relative;
      left: 20px;
    }

    .content, .wrap {
      text-align: center;
      max-width: 320px;
    }

    .wrap {
      flex-direction: column;
    }
    .img {
      order: 1;
      width: 80%;
      margin-right: auto;
      margin-left: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// components/Thirds.vue